// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonUnknownstate_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="8" cy="8" r="8" class="svg-bg"/>
  <path d="M11 6.64494C11 5.18411 9.6426 4 7.96861 4 6.50648 4 5.28529 4.90375 5 6.10621L6.72955 6.64494C6.72955 6.04878 7.28584 5.56395 7.96843 5.56395 8.65156 5.56395 9.20732 6.04878 9.20732 6.64494 9.20732 7.04754 8.95309 7.3995 8.57787 7.58532 7.98491 7.88696 7.52111 8.36017 7.27202 8.92536 7.18787 9.11799 7.1287 9.32069 7.09769 9.53159H7.09929V10H8.93112V9.53159H8.92776C9.02626 9.27222 9.23442 9.05636 9.50459 8.92536H9.50282C10.3989 8.46624 11 7.61706 11 6.64494ZM9 11H7V13H9V11Z" class="svg-fg"/>
</svg>
`;
/**
 * IconCommonUnknownstate is a generated icon component.
 */
let IconCommonUnknownstate = IconCommonUnknownstate_1 = class IconCommonUnknownstate extends IconBaseElement {
    render() {
        return html `${IconCommonUnknownstate_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonUnknownstate.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconCommonUnknownstate = IconCommonUnknownstate_1 = __decorate([
    customElement('zui-icon-common-unknownstate')
], IconCommonUnknownstate);
export { IconCommonUnknownstate };
